import type { FieldPolicy } from '@apollo/client';
import { unionBy } from 'lodash';

import type { PermissionInfo } from 'common/components/withPermissions/fragments';

const permissionsFieldPolicy: FieldPolicy = {
  merge: (existing: PermissionInfo[] = [], incoming: PermissionInfo[]) =>
    // Incoming is first in the union in order to prioritize newer values
    unionBy(incoming, existing, el => el.permissionName),
};

export default permissionsFieldPolicy;
